import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class InstructionOptionsVM extends CommonOptionVM {
  default_value?: string

  constructor(data: Partial<InstructionOptionsVM> = {}) {
    super(data)
    this.default_value = data.default_value || undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default InstructionOptionsVM
